// Stripe price and product IDs for Sentinela de Caixa

export const STRIPE_PLANS = {
  // Plano Sentinela - R$ 97/mês
  sentinela_monthly: {
    price_id: "price_1StC8eA9jIfuuE6mLmtnSBH3",
    product_id: "prod_TqtwJXQOsHAdYO",
    tier: "sentinela" as const,
    name: "Sentinela",
    price: 97,
    interval: "mês",
    description: "Para quem quer clareza e controle mensal.",
  },
  sentinela_annual: {
    price_id: "price_1StC8sA9jIfuuE6meAxgAmPJ",
    product_id: "prod_TqtwwOVbC19DYB",
    tier: "sentinela" as const,
    name: "Sentinela",
    price: 776,
    interval: "ano",
    description: "Para quem quer clareza e controle mensal.",
    savings: "2 meses grátis",
  },
  // Plano Sentinela Premium - R$ 297/mês
  premium_monthly: {
    price_id: "price_1Stql0A9jIfuuE6m6uUeXmu4",
    product_id: "prod_TrZuD8arGt9ZyR",
    tier: "premium" as const,
    name: "Sentinela Premium",
    price: 297,
    interval: "mês",
    description: "Para quem quer antecipar problemas antes que apareçam.",
  },
  premium_annual: {
    price_id: "price_1Stql0A9jIfuuE6m6uUeXmu4",
    product_id: "prod_TrZuD8arGt9ZyR",
    tier: "premium" as const,
    name: "Sentinela Premium",
    price: 2970,
    interval: "ano",
    description: "Para quem quer antecipar problemas antes que apareçam.",
    savings: "2 meses grátis",
  },
  // Plano Ultra Premium - R$ 697/mês
  ultra_monthly: {
    price_id: "price_1StqlWA9jIfuuE6m6GPcDHO3",
    product_id: "prod_TrZvtUVmYn3OMt",
    tier: "ultra" as const,
    name: "Ultra Premium",
    price: 697,
    interval: "mês",
    description: "Proteção máxima com módulo Cardápio.",
  },
  ultra_annual: {
    price_id: "price_1StqlkA9jIfuuE6modNzNOQv",
    product_id: "prod_TrZvm9pgjcCflv",
    tier: "ultra" as const,
    name: "Ultra Premium",
    price: 5790,
    interval: "ano",
    description: "Proteção máxima com módulo Cardápio.",
    savings: "12x R$ 579",
  },
} as const;

export type PlanType = keyof typeof STRIPE_PLANS;
export type PlanTier = "sentinela" | "premium" | "ultra";

// Helper to get plan tier from product ID
export function getPlanTierFromProductId(productId: string): PlanTier | null {
  for (const plan of Object.values(STRIPE_PLANS)) {
    if (plan.product_id === productId) {
      return plan.tier;
    }
  }
  return null;
}

// Features for each tier
export const PLAN_FEATURES = {
  sentinela: [
    "Diagnóstico completo do mês",
    "Índice Sentinela",
    "Alertas claros de risco",
    "Leitura do relatório do contador (se enviar)",
    "Fatores que pressionam o caixa",
    "Histórico mensal",
    "Relatório em PDF",
  ],
  premium: [
    "Tudo do plano Sentinela, mais:",
    "Alertas preditivos",
    "Leitura de tendência do negócio",
    "Avaliação mais profunda da sustentabilidade",
    "Comparação histórica mais inteligente",
    "Diagnóstico mais estratégico",
    "Relatório PDF premium",
  ],
  ultra: [
    "Tudo do plano Premium, mais:",
    "Relatórios Executivos automáticos para sócios",
    "Módulo Cardápio completo",
    "Sugestões de ajuste de preço por prato",
    "Análise de elasticidade de preços",
    "Identificação de pratos com baixo retorno",
    "Otimização de rentabilidade",
    "Acompanhamento de decisões de preço",
  ],
} as const;
